import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { ModalReactivateComponent } from './modal-reactivate.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalReactivateComponent],
  providers: [],
})
export class ModalReactivateModule {}
